import { render, staticRenderFns } from "./Reinvite.vue?vue&type=template&id=72947f4a&scoped=true"
import script from "./Reinvite.vue?vue&type=script&lang=ts"
export * from "./Reinvite.vue?vue&type=script&lang=ts"
import style0 from "./Reinvite.vue?vue&type=style&index=0&id=72947f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72947f4a",
  null
  
)

export default component.exports